import { types, actions } from './requests'
export const GETORGANIZATIONLIST_TYPES = {
    ...types('GETORGANIZATIONLIST'),
}
export const GETORGANIZATIONLIST_ACTIONS = {
    ...actions('GETORGANIZATIONLIST'),
}
